// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___2_zHH","label":"styles__label___xdzIe"};